<template>
<div></div>
</template>

<script>
import GlobalStrorage from '../global/GlobalStrorage';
import apifactory from "../apis/apifactory";
export default {

    name: 'AuthAction',
    props: {
        parm_step: {
            type: Number,
            default: 0,
        }
    },
    data() {
        return {
            dialog: false,
            maxstep: 0,
            nextstep: 1,

        }
    },
    methods: {
        getmaxstep() {
           // alert('Hi Sorry');
            apifactory.getthemaxstep()
                .then((res) => {

                    if (res.status != 200) {
                        //this.prevstepQueryStringParm = '';
                        alert('Sorry');

                    } else {

                        //alert("DataUploaddata:---" + JSON.stringify(res.data));
                        //alert(JSON.stringify(res.data));
                        this.maxstep = res.data["maxstep"];
                        if( this.maxstep === 6 && this.parm_step ===9){
                            this.nextstep = 9;
                        }
                        else{
this.nextstep = this.maxstep + 1;
                        }
                        
                        // alert('maxstep' + this.maxstep);
                        //alert('parm_step' + this.parm_step);
                        //alert('nextstep' + this.nextstep);
                        if (this.parm_step > this.nextstep) {
                            // alert('no valid');
                             this.validateAction();
                        }
                        

                        //alert('maxstep' + this.maxstep);
                        //alert('parm_step' + this.parm_step);
                        //alert('nextstep' + this.nextstep);
                       

                    }
                })
                .catch(function (error) {
                    console.warn(error);
                });
        },
        validateAction() {
            // alert("parm_step" +this.parm_step);

            //alert(GlobalStrorage.getcurrentstep());
            let tempcurrentstep = GlobalStrorage.getcurrentstep();
            //alert("parm_current" + tempcurrentstep);
            let inttempcueent = parseInt(tempcurrentstep);
            alert(inttempcueent);
            //inttempcueent=this.nextstep;
            if (tempcurrentstep < this.parm_step) {
                //if (this.parm_step <= this.nextstep) {
                // alert("sorry please complete privious steps ." + tempcurrentstep);
                //alert("sorry please complete privious steps .");
                this.$swal(
                    'sorry please complete privious steps .'
                )
                switch (inttempcueent) {
                     case 0:
          this.$router.push("/settingproject");
          break;
        case 1:
          this.$router.push("/settingproject");
          break;
        case 2:
          this.$router.push("/edaprocess");
          break;
        case 3:
          this.$router.push("/dataprocess");
          break;
        case 4:
          this.$router.push("/dataprocess");
          break;
        case 5:
          this.$router.push("/dataprocess");
          break;
        case 6:
          this.$router.push("/modeldataprocess");
          break;
       
        default:
          this.$router.push("/dashboard");
                }

            }
        }
    },
    mounted() {
       // this.getmaxstep();

    },
};
</script>

<style scoped>
.header-icon-space {
    padding-right: 10px !important;
}
</style>
